<template>
  <modal class="modal" name="payment-modal" transition="pop-out" :width="modalWidth" :height="260" :adaptive="true" :clickToClose="false"
         @before-open="beforeOpen">
    <div class="flex flex-column items-center justify-center mb3">
      <div class="flex justify-end w-100">
        <a @click="closeModal" class="pa3 pointer textColor">
          <font-awesome-icon icon="times" size="2x"/>
        </a>
      </div>
      <div class="h2 heigthMobile">
        <clip-loader :loading="isLoadingLink" :color="color" :size="size"></clip-loader>
      </div>
      <div class="mb4 flex items-center flex-wrap justify-center">
        <div v-if="user.country === 'argentina' || user.country === 'Argentina' || user.country === 'ARG' || user.country === 'AR' || providerCountry === 'ARG'">
          <button @click="getPaymentLink('mercadopago')" :disabled="disabled"
                  class="payment-button mh2 pointer borderButton"
                  :class="{ 'disabled': disabled }">
            <div class="h2" style="width: 190px">
              <img src="../../assets/mercado-pago.png">
            </div>
          </button>
          <div style="min-height: 17.5px;">    </div>
        </div>
        <div>
        <paypal-payment :track="track" :value="valueUSD" :ppPlans="ppPlans" :refCode="refCode" :voucher="voucher"></paypal-payment>
        <span v-if="user.country === 'argentina' || user.country === 'Argentina' || user.country === 'ARG' || user.country === 'AR' || providerCountry === 'ARG'" style="display: flex; justify-content: center;">Aplica tarifa internacional USD {{ pricing[0].amount }} </span>
        </div>
        <span v-if="voucher" class="accent fsize15">El Beneficio del Voucher ( {{voucher.months}} meses gratis )<span v-if="voucher.months !== 3"> sólo es aplicable con Mercado Pago.</span></span>
        <p class="w-100 tc textColor">{{ $t("users.payment.message") }}</p>
        <p v-if="user.country === 'argentina' || user.country === 'Argentina' || user.country === 'ARG' || user.country === 'AR' || providerCountry === 'ARG'" class="w-100 tc textColor">{{ message }}</p>
      </div>
    </div>
  </modal>
</template>

<script>
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import {mapActions, mapGetters} from 'vuex'
  import PaypalPayment from './PaypalPayment.vue'

  const MODAL_WIDTH = 600

  export default {
    name: 'payment-modal',
    components: {
      FontAwesomeIcon,
      ClipLoader,
      PaypalPayment
    },
    data () {
      return {
        modalWidth: MODAL_WIDTH,
        color: '#808080',
        size: '30px',
        paymentUrl: '',
        email: '',
        currency: 'ARS',
        track: null,
        disabled: false,
        tab: null,
        providerCountry: null,
        voucher: null,
        ppPlans: null,
        suggestedValues: null,
        index: null,
        valueARS: 0,
        valueUSD: 0,
        message: '',
        refCode: null
      }
    },
    computed: {
      isLoadingLink () {
        return this.$loading.isLoading('user getSubscriptionLink') || this.$loading.isLoading('track getBuyLink')
      },
      ...mapGetters('user', [
        'user'
      ]),
      ...mapGetters('pricing', [
        'pricing'
      ])
    },
    created () {
      this.providerCountry = localStorage.getItem('providerCountry')
      this.getPPplans().then((plans) => {
        if (plans) {
          this.ppPlans = plans
        }
      })
    },
    methods: {
      ...mapActions('user', [
        'getSubscriptionLink'
      ]),
      ...mapActions('track', [
        'getBuyLink'
      ]),
      ...mapActions('home', [
        'getPPplans'
      ]),
      closeModal () {
        this.valueARS = 0
        this.valueUSD = 0
        localStorage.removeItem('userFromLandingMK')
        this.$modal.hide('payment-modal')
      },
      beforeOpen (event) {
        this.disabled = false
        this.paymentUrl = event.params.paymentUrl
        this.voucher = event.params.voucher
        this.refCode = event.params.refCode
        if (event.params.track) {
          this.track = event.params.track
          this.email = event.params.email
          this.suggestedValues = event.params.suggestedValues
          if (event.params.currency === 'ARS') {
            this.message = 'Abonando con Paypal se cobrará el valor del track en USD'
            this.suggestedValues.ARS.forEach((element, idx) => {
              if (parseFloat(element) === parseFloat(event.params.value)) {
                this.index = idx
              }
            })
            this.valueARS = this.suggestedValues.ARS[this.index]
            this.valueUSD = this.suggestedValues.USD[this.index]
          }
          if (event.params.currency === 'USD') {
            this.message = 'Abonando con Mercado Pago se cobrará el valor del track en ARS'
            this.suggestedValues.USD.forEach((element, idx) => {
              if (parseFloat(element) === parseFloat(event.params.value)) {
                this.index = idx
              }
            })
            this.valueARS = this.suggestedValues.ARS[this.index]
            this.valueUSD = this.suggestedValues.USD[this.index]
          }
        } else {
          this.track = null
          this.valueARS = 0
          this.valueUSD = 0
        }
      },
      getPaymentLink (gateway) {
        // this.tab = window.open('', '_blank') mercadopago
        this.disabled = true

        if (this.track) {
          this.getTrackLink(gateway)
        } else if (gateway === 'mercadopago') {
          this.$modal.show('set-email-modal', {
            paymentUrl: this.paymentUrl,
            voucher: this.voucher,
            refCode: this.refCode,
            gateway: gateway
          })
          this.closeModal()
        } else {
          this.getSubsLink(gateway)
        }
      },
      getSubsLink (gateway) {
        this.getSubscriptionLink({gateway: gateway, paymentUrl: this.paymentUrl, voucher: this.voucher, refCode: this.refCode}).then(nextUrl => {
          window.location.href = nextUrl
        }).catch(e => {
          if (e.message === 'Ya se encuentra una suscripción activa para este usuario') {
            localStorage.removeItem('userFromLandingMK')
            this.$modal.hide('payment-modal')
            this.disabled = false
            this.$router.push({path: '/home'})
          }
          if (e.message === 'Invalid Voucher Code') {
            this.$modal.hide('payment-modal')
          }
          this.$toasted.show(e.message, {type: 'error'})
          this.disabled = false
        })
      },
      getTrackLink (gateway) {
        this.getBuyLink({
          value: this.valueARS,
          track: this.track,
          gateway: gateway,
          currency: this.currency
        }).then((nextUrl) => {
          window.location.href = nextUrl
          this.$toasted.show(this.$t('tracks.buyTrack.emailMessage'), {type: 'success'})
          this.disabled = false
          this.$modal.hide('payment-modal')
        }).catch((e) => {
          this.tab = null
          this.$toasted.show(e.message, {type: 'error'})
          this.disabled = false
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .modal {
    z-index: 10000;
  }

  .payment-button {
    background-color: #393839;
    border: none;
  }

  .payment-button:hover, .payment-button:focus {
    border: 2px solid #555555;
    border-radius: 4px;
    opacity: .5;
  }

  .disabled:hover {
    border: none !important;
    opacity: 1 !important;
    cursor: not-allowed;
  }

  .borderButton {
    border-radius: 4px;
    background-color: white;
    margin: 0.5rem;
  }

  .fsize15 {
    font-size: 15px;
    font-weight: bolder
  }

  @media (min-width:300px) and (max-width:600px) {
    .heigthMobile{
      height: 0px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/PaymentModal.vue